import { ActionTree } from 'vuex';
import axios from 'axios';
import { IndustryState, Industry, RootState } from './industry-types';

export const actions: ActionTree<IndustryState, RootState> = {
  async getIndustries({ commit }): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-industry' }).then(
      (response) => {
        const payload: Industry = response && response.data;
        commit('setIndustriesInState', payload);
      },
      (error) => {
        console.log(error);
        commit('profileError');
      },
    );
  },
};
